import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import FulfillmentTrackingInfos from './fulfillment-tracking-infos'
import { orderPath } from 'lib/urls'
import withExpiration from 'shared/with-expiration'

const OrderActions = ({
  cancelUntil,
  canCancel,
  statusWebUrl,
  trackingInfos,
  returnWebUrl,
  uuid,
}) => {
  const InfoButtonWithExpiration = withExpiration(InfoButton)
  const trackingInfoButton = (
    <InfoButton
      className="mtm btn-block text-brand-info"
      empty
      pill
      newWindow
    ></InfoButton>
  )
  const subscriptionSetupButton = (
    <InfoButton className="mtm btn-block" pill newWindow></InfoButton>
  )

  return (
    <div className="mtl">
      {statusWebUrl && (
        <InfoButton
          className="mtm phxl btn-block"
          href={statusWebUrl}
          pill
          newWindow
        >
          Order status
        </InfoButton>
      )}
      {canCancel && (
        <InfoButtonWithExpiration
          className="mtm phxl btn-block"
          empty
          expiresAt={cancelUntil}
          href={orderPath(uuid)}
          newWindow
          pill
        >
          Cancel order
        </InfoButtonWithExpiration>
      )}
      <FulfillmentTrackingInfos
        subscriptionSetupButton={subscriptionSetupButton}
        trackingInfoButtonComponent={trackingInfoButton}
        trackingInfos={trackingInfos}
      />
      {returnWebUrl && (
        <InfoButton
          className="mtm phxl btn-block text-brand-info"
          href={returnWebUrl}
          empty
          pill
          newWindow
        >
          Return items
        </InfoButton>
      )}
    </div>
  )
}

OrderActions.defaultProps = {
  statusWebUrl: null,
  returnWebUrl: null,
  trackingInfos: [],
}

OrderActions.propTypes = {
  cancelUntil: PropTypes.string.isRequired,
  canCancel: PropTypes.bool.isRequired,
  statusWebUrl: PropTypes.string,
  returnWebUrl: PropTypes.string,
  trackingInfos: PropTypes.arrayOf(PropTypes.object),
  uuid: PropTypes.string.isRequired,
}

export default OrderActions
